import React from 'react';
import { Input, Modal, Typography, Space, Divider, Alert } from 'antd';
import { MailOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { L } from '@lib';

interface IEmailSendModalProps {
  open: boolean;
  title: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  emailValue: string;
  setEmailValue: (val: string) => void;
  emailError?: string | null;
  okButtonProps?: React.ComponentProps<typeof Modal>['okButtonProps'];
}

export const EmailSendModal: React.FC<IEmailSendModalProps> = ({
  open,
  title,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  emailValue,
  setEmailValue,
  emailError,
  okButtonProps,
}) => (
  <Modal
    open={open}
    title={
      <Space align="center" style={{ gap: 8 }}>
        <MailOutlined style={{ color: '#1677ff', fontSize: 22, verticalAlign: 'middle' }} />
        <Typography.Text style={{ fontSize: 18, fontWeight: 600, verticalAlign: 'middle', lineHeight: '22px' }}>
          {title}
        </Typography.Text>
      </Space>
    }
    onOk={onConfirm}
    onCancel={onCancel}
    okText={confirmText}
    cancelText={cancelText}
    okButtonProps={okButtonProps}
    bodyStyle={{ paddingTop: 24, paddingBottom: 16 }}
  >
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <div>
        <Typography.Text strong style={{ fontSize: 14, display: 'block', marginBottom: 6 }}>
          Customer email
        </Typography.Text>
        <Input
          prefix={
            <MailOutlined
              style={{
                color: '#1677ff',
                fontSize: 16,
                verticalAlign: 'middle',
                marginRight: 6,
                marginLeft: 2,
                display: 'inline-flex',
                alignItems: 'center',
                height: '100%',
              }}
            />
          }
          placeholder={L('Enter email address')}
          size="large"
          value={emailValue}
          onChange={e => setEmailValue(e.target.value)}
          status={emailError ? 'error' : ''}
          style={{
            marginTop: 8,
            fontSize: 15,
          }}
          inputMode="email"
        />
        {emailError && (
          <Typography.Text type="danger" style={{ fontSize: 12, marginTop: 4, display: 'block' }}>
            {emailError}
          </Typography.Text>
        )}
      </div>
      <Divider style={{ margin: '12px 0' }} />
      <Alert
        type="info"
        showIcon
        icon={<InfoCircleOutlined />}
        message="Disclaimer"
        description={
          <Typography.Text type="secondary" style={{ fontSize: 13 }}>
            Have in mind that private data and payment information will be sent over email. Please ensure the recipient's email address is correct and secure.
          </Typography.Text>
        }
      />
    </Space>
  </Modal>
);
